import { Component, createRef, type ReactNode } from 'react';

type BoundsState = {
  rect?: ClientRect | DOMRect;
  parentRect?: ClientRect | DOMRect;
};

type BoundsProps = {
  render: (bounds: { rect?: ClientRect | DOMRect; parentRect?: ClientRect | DOMRect }) => ReactNode;
};

class Bounds extends Component<BoundsProps, BoundsState> {
  private nodeRef = createRef<HTMLDivElement>();

  constructor(props: BoundsProps) {
    super(props);
    this.state = {
      rect: undefined,
      parentRect: undefined,
    };
  }

  public componentDidMount() {
    // oxlint-disable-next-line react/no-did-mount-set-state -- measuring the DOM node's bounding rect requires a ref that isn't attached until after mount; there is no way to read layout before this and re-render once with it
    this.setState(() => this.getBoundingRects());
  }

  private getBoundingRects(): BoundsState {
    const node = this.nodeRef.current;
    if (node) {
      const rect = node.getBoundingClientRect();
      const parentRect = node.parentElement ? node.parentElement.getBoundingClientRect() : undefined;
      return {
        rect,
        parentRect: parentRect || undefined,
      };
    }
    return {
      rect: undefined,
      parentRect: undefined,
    };
  }

  public render() {
    const { rect, parentRect } = this.state;

    return (
      <div ref={this.nodeRef}>
        {this.props.render({
          rect,
          parentRect,
        })}
      </div>
    );
  }
}

export { Bounds };
export default Bounds;
